import { makeStyles, Tooltip } from "@fluentui/react-components";
import { NewRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { VsaaColorTokens } from "../../style/VsaaColorTokens";

const useStyles = makeStyles({
  indicator: {
    alignItems: "center",
    color: VsaaColorTokens.color_new_document_indicator,
    display: "inline-flex",
    flexShrink: 0,
    lineHeight: 0,
    left: "-9px",
    opacity: 0.75,
    position: "absolute",
    top: "-6px",
    zIndex: 1,
    "& svg": {
      height: "14px",
      width: "14px",
    },
  },
});

const PublishedDocumentNewIndicator = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const label = t("newDocument");

  return (
    <Tooltip content={label} relationship="label">
      <span aria-label={label} className={classes.indicator} role="img">
        <NewRegular />
      </span>
    </Tooltip>
  );
};

export default PublishedDocumentNewIndicator;
